import { Component, Input } from '@angular/core';
import { swiperBreakpoints } from '../../utils/swiperBreakpoints';
import { IVideo } from '../../interfaces/videosByCategory';
import SwiperCore, { Navigation, Pagination } from 'swiper';

SwiperCore.use([Navigation, Pagination]);

@Component({
  selector: 'app-swiper-component',
  templateUrl: './swiper-component.component.html',
  styleUrl: './swiper-component.component.scss'
})
export class SwiperComponentComponent {
  @Input() videos: IVideo[] = [];
  @Input() index: number;
  @Input() showButtons: boolean = true;
  @Input() bgTheme: 'dark' | 'light' = 'light';

  swiperBreakpoints = swiperBreakpoints;

  getEmptySlots(videoCount: number): null[] {
    const minItems = this.getSlidesPerView();
    const emptySlots = videoCount < minItems ? minItems - videoCount : 0;

    return Array.from({ length: emptySlots });
  }

  getSlidesPerView(): number {
    const width = window.innerWidth;

    if (width >= 3840) return 14;
    if (width >= 3776) return 13;
    if (width >= 3544) return 12;
    if (width >= 3312) return 11;
    if (width >= 3080) return 10;
    if (width >= 2848) return 9;
    if (width >= 2616) return 8;
    if (width >= 2384) return 7;
    if (width >= 2152) return 6;
    if (width >= 1920) return 6;
    if (width >= 1600) return 5;
    if (width >= 1400) return 4;
    if (width >= 1366) return 4;
    if (width >= 1200) return 4;
    if (width >= 992) return 4;
    if (width >= 768) return 3;
    if (width >= 576) return 1;

    return 1;
  }

  onImageHeightChanged(height: number) {
    document.documentElement.style.setProperty(
      '--swiper-buttons-top-position',
      `${height / 2 - 20}px`
    );
  }
}
